export default __webpack_public_path__ + "locales/en/Payments.json?hash=326455b43d30c889a3f091d0337015e0";